module.exports = __webpack_public_path__ + "static/04_home_screen_v2.32e8ead9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/04_home_screen_v2.jpg
// module id = 513
// module chunks = 111663361672460